export const apiLinks = () => {
    return {
        env: 'development',
        url: 'https://dev-api.credicorp-register.ng/api/v1/',
        url2: 'https://dev-api.credicorp-register.ng/api/v2/',
        awsKey: 'development/',
        applicationLink: 'https://dev.apply.credicorp-register.ng/apply'
    };
}